module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bi-5d3435104d6a6e67937cde02313d2d31.svg";